export const SET_LAST_GENERATED_MEMBER = "SET_LAST_GENERATED_MEMBER";
export const SET_MINT_ENABLED_STATUS = "SET_MINT_ENABLED_STATUS";



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/clientActionTypes.js